import { Inbox } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { SalesInboxPage } from './pages/SalesInboxPage'
import { SalesIntakePage } from './pages/SalesIntakePage'

/**
 * Sales Inbox — Sprint 21 (2026-05-06).
 *
 * Where ops staff land customer sales orders (PDF / XLSX / email
 * attachments) and review them before pushing to Odoo as draft sale.order
 * records. Mirrors the CofA Management pattern: queue-based uploader,
 * backend pipeline with state machine, master/detail UI.
 *
 * Also the destination CARLA pushes to when she begins monitoring the
 * orders inbox autonomously (Sprint 19 v2 follow-on).
 *
 * Permissions per Sprint 21 D-5:
 *   admin · sales · operations — full access (view + edit + confirm)
 *   inside_sales_rep — view + edit; confirm restricted server-side
 *     (Sprint 16 customer-scope resolver filters intake records to
 *     their assigned customers)
 *
 * outside_sales_rep excluded (2026-07-21): password-login field reps get
 * a narrowed sidebar (Orders + Quotes only) — no Sales Inbox.
 */
export default defineModule({
  id: 'sales-inbox',
  name: 'Sales Inbox',
  shortName: 'Sales Inbox',
  icon: Inbox,
  navSection: 'sales',
  navOrder: 5,
  urlNamespace: '/sales-inbox',
  routes: [
    { path: '/', element: SalesInboxPage, label: 'Sales Inbox' },
    { path: '/$intakeId', element: SalesIntakePage, label: 'Sales order' },
  ],
  permissions: [
    'admin',
    'sales',
    'operations', 'operations_logistics', 'purchasing',
    'inside_sales_rep',
  ],
  densityDefault: 'comfortable',
  mobileStrategy: 'desktop-only',

  keyboardShortcut: 'g x',

  commandPaletteEntries: [
    {
      label: 'Go to Sales Inbox',
      keywords: [
        'sales',
        'inbox',
        'order',
        'po',
        'upload',
        'review',
        'customer',
        'intake',
      ],
      path: '/',
      group: 'modules',
      shortcut: 'g x',
    },
    {
      label: 'Upload customer sales order',
      keywords: ['upload', 'sales', 'order', 'po', 'pdf'],
      path: '/?action=upload',
      group: 'modules',
    },
  ],
})
